module.exports = __webpack_public_path__ + "static/media/sv.fe725901.svg";